export const TOGGLE_SURVEY_SENT_STATUS = 'TOGGLE_SURVEY_SENT_STATUS';
export type TOGGLE_SURVEY_SENT_STATUS = typeof TOGGLE_SURVEY_SENT_STATUS;

export const CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED = 'CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED';
export type CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED = typeof CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED;


// WEBPACK FOOTER //
// ./src/store/Survey/constant.ts